import normalizeUS from './normalizeUS';

function formatUSPhoneNumber(number) {
  if (!number) return number;
  try {
    // Remove all non-digit characters
    const tmpNumber = normalizeUS(number);
    const digits = tmpNumber.replace(/\D/g, '');
    if (digits.length !== 10) return number;
    const area = digits.slice(0, 3);
    const prefix = digits.slice(3, 6);
    const line = digits.slice(6, 10);
    return `(${area}) ${prefix}-${line}`;
  } catch {
    return number;
  }
}
export default formatUSPhoneNumber;
